export const formatMediaList = (platforms: string[], maxShow = 2): string => {
  if (platforms.length === 0) return '-';
  if (platforms.length <= maxShow) return platforms.join(', ');
  return `${platforms.slice(0, maxShow).join(', ')} +${platforms.length - maxShow}`;
};

export const formatMediaLabel = (media: string): string => {
  return media
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
